import PropTypes from "prop-types";
import React, { Component } from "react";

import KEYS from "../../main/constants/keys";

import {
  PrimaryFieldWrapper,
  PrimaryInputWrapper,
  PrimaryError,
  Input,
  SubmitButton,
  CustomizeSubmitButton
} from "./PrimaryAddress";

import emailIcon from "../images/icon-email-search.svg";

class PrimaryEmail extends Component {
  constructor(props) {
    super(props);

    this.state = { submitted: false };
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleKeyDown(e) {
    switch (KEYS[e.keyCode]) {
      case "enter":
        return this.handleSubmit();
      default:
        return;
    }
  }
  handleSubmit() {
    this.setState({ submitted: true });
    return this.props.submitPrimary("email");
  }
  render() {
    const { design, inputValue, customizable, changeFieldValue, error } =
      this.props;
    const { submitted } = this.state;
    const errorMessage =
      submitted && error ? (
        <PrimaryError font={design.font}>{error}</PrimaryError>
      ) : null;

    if (customizable) {
      return (
        <PrimaryInputWrapper>
          <Input
            disabled
            type="text"
            font={design.font}
            placeholder={"Enter your email address"}
          />
          <CustomizeSubmitButton
            // NOTE: Hackiness to make Customize Mobile view work consistently
            style={{
              backgroundColor: design.accentColor,
              backgroundImage: `url(${emailIcon})`
            }}
          />
        </PrimaryInputWrapper>
      );
    }

    return (
      <PrimaryFieldWrapper>
        <PrimaryInputWrapper>
          <Input
            autoFocus
            type="text"
            value={inputValue}
            font={design.font}
            placeholder={"Enter your email address"}
            onChange={(e) => changeFieldValue("email", e.target.value)}
            onKeyDown={this.handleKeyDown}
          />
          <SubmitButton
            bgColor={design.accentColor}
            bgImg={emailIcon}
            onClick={this.handleSubmit}
          />
        </PrimaryInputWrapper>
        {errorMessage}
      </PrimaryFieldWrapper>
    );
  }
}

PrimaryEmail.propTypes = {
  design: PropTypes.object.isRequired,
  customizable: PropTypes.bool,
  inputValue: PropTypes.string,
  changeFieldValue: PropTypes.func,
  submitPrimary: PropTypes.func,
  error: PropTypes.string
};

export default PrimaryEmail;
